/** The raw browser User-Agent string (empty during SSR / no navigator). */
export function getUserAgent(): string {
  return typeof navigator !== "undefined" ? navigator.userAgent : "";
}
